export default {
    computed: {
        // 电池类型
        getBatteryType() {
            return [
                {
                    value: 0,
                    label: "Lithium lon"
                },
                {
                    value: 1,
                    label: "Lithium Metal"
                },
                {
                    value: 2,
                    label: "Lead acid"
                }
            ]
        },
        // 电池包装类型
        getBatteryPackageType () {
            return [
                {
                    value: 0,
                    label: "Alone in box"
                },
                {
                    value: 1,
                    label: "Contained or installed in equipment"
                },
                {
                    value: 2,
                    label: "Packaged separately with other equipment"
                }
            ]
        },
        // 是否张贴电池标
        getIsBatteryLabel () {
            return [
                {
                    trueValue: 1,
                    label: this.$t('uc.data_bool.yes', { defaultValue: "是" })
                },
                {
                    trueValue: 0,
                    label: this.$t('uc.data_bool.no', { defaultValue: "否" })
                },
            ]
        },
        // 电池标类型
        getBatteryLabelType () {
            return [
                {
                    value: 0,
                    label: "UN3480 (lithium Ion Standalone)"
                },
                {
                    value: 1,
                    label: "UN3481 (lithium Ion in & With)"
                },
                {
                    value: 2,
                    label: "UN3090 (lithium Metal Standalone)"
                },
                {
                    value: 3,
                    label: "UN3091 (Lithium Metal In & With Equipment)"
                },
                {
                    value: 4,
                    label: "Other"
                }
            ]
        }
    }
}
